import axios from './companyHttp'

export type NotificationType = 'INBOX_EMAIL' | 'ISSUE_ASSIGNED'
export interface Notification {
  id: string
  type: NotificationType
  title: string
  detail: string
  link: string
  subject_key: string
  group_key: string
  read_at: string | null
  unread: boolean
  date_created: string
}
export interface NotificationPreference {
  type: NotificationType
  enabled: boolean
}
export type ReadTarget =
  | { ids: string[] }
  | { type: NotificationType; subject_key: string }
  | { issue: string }
  | { all: true }

const endpoint = '/api/v1/notifications/'
export const getNotifications = async (): Promise<Notification[]> => (await axios.get(endpoint)).data
export const getUnreadCount = async (type?: NotificationType): Promise<{ count: number }> =>
  (await axios.get(`${endpoint}unread-count/`, { params: type ? { type } : undefined })).data
export const markNotificationsRead = async (target: ReadTarget): Promise<void> => {
  await axios.post(`${endpoint}mark-read/`, target)
}
export const getNotificationPreferences = async (): Promise<NotificationPreference[]> =>
  (await axios.get(`${endpoint}preferences/`)).data
export const setNotificationPreference = async (
  preference: NotificationPreference
): Promise<NotificationPreference[]> => (await axios.put(`${endpoint}preferences/`, preference)).data
